export const FETCH_USER_STATUS_STARTED = 'FETCH/USER/STATUS/STARTED';
export const FETCH_USER_STATUS_SUCCESS = 'FETCH/USER/STATUS/SUCCESS';
export const FETCH_USER_STATUS_FAILURE = 'FETCH/USER/STATUS/FAILURE';

export const FETCH_SUPPORT_INFO_STARTED = 'FETCH/SUPPORT_INFO/STARTED';
export const FETCH_SUPPORT_INFO_SUCCESS = 'FETCH/SUPPORT_INFO/SUCCESS';
export const FETCH_SUPPORT_INFO_FAILURE = 'FETCH/SUPPORT_INFO/FAILURE';
